import { Container } from '@/components/Container/Container';
import { ESize } from '@/models/enums';
import Image from 'next/image';

export const PartnersAndAcknowledgementsBanner = () => {
  return (
    <>
      <section className="bg-secondary">
        <Container size={ESize.MD} additionalClassNames="flex flex-col items-center text-center py-8">
          <div className="flex flex-col">
            <h3 className="mb-4">Partners</h3>
            <p>
              The Diabetes Alliance Program Plus <br /> is a partnership between
            </p>
          </div>
          <div className="flex flex-col md:flex-row flex-wrap gap-16 md:gap-18 items-center justify-center py-8">
            <Image height={90} width={135} src="/images/hmri.png" alt="HMRI logo" />
            <Image height={70} width={70} src="/images/university-of-newcastle-logo.svg" alt="UoN logo" />
            <Image
              height={120}
              width={230}
              src="/images/hnev-logo.svg"
              alt="Hunter New England Local Health District logo"
              className="mx-auto"
            />
            <Image
              height={120}
              width={230}
              src="/images/primary-health-network-logo.svg"
              alt="Primary health newtwork logo"
              className="mx-auto"
            />
          </div>
        </Container>
      </section>
      <section>
        <Container size={ESize.MD} additionalClassNames="flex flex-col items-center text-center py-8">
          <h3 className="mb-4">Acknowledgements</h3>
          <div className="flex flex-col gap-4">
            <p>
              Diabetes Alliance Program Plus acknowledges Traditional Owners of Country throughout Australia and recognises the continuing
              connection to lands, waters and communities. We pay our respect to Aboriginal and Torres Strait Islander cultures; and to
              Elders past and present.
            </p>
          </div>
          <Image src="/images/acknowledgementsFlags.svg" alt="Aboriginal and Torres Strait Islander flags" height={70} width={140} />
        </Container>
      </section>
    </>
  );
};

export default PartnersAndAcknowledgementsBanner;
